"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectItem = void 0;
const react_1 = __importStar(require("react"));
const hooks_1 = require("../../../../../shared/hooks");
const StackPanel_1 = require("../../../../Layout/StackPanel/StackPanel");
const config_1 = require("../../config");
const hooks_2 = require("../../hooks");
const SelectList_styles_1 = require("../SelectList/SelectList.styles");
const SelectItem = ({ option, index, ariaPosInset, ariaSetSize, shouldDisplayValue, valueDescription, onListItemClick, }) => {
    const { theme, setSelected = () => [], selected, setExpanded, } = (0, hooks_2.useSelect)();
    const itemRef = (0, react_1.useRef)(null);
    const shouldDisplayOptionValue = shouldDisplayValue && !option.shouldHideValue && option.value !== "";
    const handleKeyDown = () => {
        selectHandler();
    };
    (0, hooks_1.useKey)([config_1.KEYS.SPACE, config_1.KEYS.ENTER], handleKeyDown, {
        target: itemRef,
    });
    const selectHandler = (event) => {
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        if (theme === "DEFAULT" && !option.disabled) {
            option.value && setSelected(option);
            setExpanded && setExpanded(false);
        }
        if ((theme === "MULTISELECT" || theme === "MULTISELECTALL") &&
            Array.isArray(selected) &&
            option.value) {
            onListItemClick && onListItemClick();
            !isChecked()
                ? setSelected([...selected, option])
                : setSelected(selected.filter((o) => o.value !== option.value));
        }
    };
    const isChecked = () => {
        return (Array.isArray(selected) &&
            !!selected.find((s) => s.value === option.value));
    };
    return (react_1.default.createElement("li", null,
        theme === "DEFAULT" && (react_1.default.createElement(SelectList_styles_1.StyledSelectItems, { role: "option", "aria-disabled": option.disabled, "aria-selected": !Array.isArray(selected) &&
                option.label === (selected === null || selected === void 0 ? void 0 : selected.label), onClick: (event) => {
                selectHandler(event);
            }, "data-testid": `select-item-${option.value}`, "aria-posinset": ariaPosInset, "aria-setsize": ariaSetSize, ref: itemRef, id: `select-item-${option.value}`, tabIndex: 0 },
            react_1.default.createElement(StackPanel_1.StackPanel, { orientation: "vertical" },
                react_1.default.createElement(SelectList_styles_1.StyledOptionLabel, { skinny: true }, option.labelElement || option.label),
                shouldDisplayOptionValue && (react_1.default.createElement(SelectList_styles_1.StyledOptionLabel, { skinny: true, colour: "metal" },
                    " ",
                    valueDescription
                        ? `${valueDescription}: `
                        : "",
                    option.value))))),
        (theme === "MULTISELECT" || theme === "MULTISELECTALL") && (react_1.default.createElement(SelectList_styles_1.StyledSelectListItems, { role: "option", tabIndex: index, "aria-disabled": option.disabled, "aria-selected": isChecked(), "aria-posinset": ariaPosInset, "aria-setsize": ariaSetSize, ref: itemRef },
            react_1.default.createElement("div", null,
                react_1.default.createElement(SelectList_styles_1.StyledSelectItemInput, { type: "checkbox", onChange: (event) => selectHandler(event), checked: isChecked(), tabIndex: -1, disabled: option.disabled, "data-testid": `select-item-${option.value}` }),
                react_1.default.createElement("span", null, option.label))))));
};
exports.SelectItem = SelectItem;
//# sourceMappingURL=SelectItem.js.map